export const consts = {
  FALSE: 0,
  TRUE: 1,

  TARGETUSER_TYPE_USER: 1,
  TARGETUSER_TYPE_INTERN: 2,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  KNOWLEDGE_STATUS_ACTIVE: 2,

  CONTENT_TYPE_IMAGE: 1,
  CONTENT_TYPE_VIDEO: 2,
  // CONTENT_TYPE_DOCUMENT: 3,
}

export const opts = {
  contentTypeMaps: [
    {value: consts.CONTENT_TYPE_IMAGE, label: '图片'},
    {value: consts.CONTENT_TYPE_VIDEO, label: '视频'},
    // { value: consts.CONTENT_TYPE_DOCUMENT, label: 'PDF' },
  ],
  targetUserMaps: [
    {value: consts.TARGETUSER_TYPE_USER, label: '零工', disable: false},
    {value: consts.TARGETUSER_TYPE_INTERN, label: '审核实习生', disable: true},
  ],
  isCommonMaps: [
    {value: consts.IS_COMMON_DEDICATED, label: '专用'},
    {value: consts.IS_COMMON_SHARED, label: '通用'},
  ],
  statusMaps: [
    {value: consts.STATUS_NEW, label: '新创建'},
    {value: consts.STATUS_ONLINE, label: '已上架'},
    {value: consts.STATUS_OFFLINE, label: '已下架'},
    {value: consts.STATUS_BANNED, label: '已作废'},
  ],
}

export function getOptionLabel (options, value) {
  const item = options.find(option => Number(option.value) === Number(value))
  return item ? item.label : ''
}

export function getCourseStatusLabel (status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态'
}

export function getCourseStatusType (status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success'
    case consts.STATUS_OFFLINE:
      return 'warning'
    case consts.STATUS_BANNED:
      return 'danger'
    default:
      return 'info'
  }
}

export function getCourseStatusActions (status, isSuperAdmin = true) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [
        {name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功'},
      ]
    case consts.STATUS_ONLINE:
      return [
        {name: 'offline', label: '下架', type: 'warning', apiName: 'offlineTrainingCourse', successText: '下架成功'},
      ]
    case consts.STATUS_OFFLINE:
      return [
        {name: 'online', label: '上架', type: 'success', apiName: 'onlineTrainingCourse', successText: '上架成功'},
        ...(isSuperAdmin
          ? [{name: 'ban', label: '作废', type: 'danger', apiName: 'banTrainingCourse', successText: '作废成功'}]
          : []),
      ]
    case consts.STATUS_BANNED:
      return isSuperAdmin
        ? [{name: 'active', label: '激活', type: 'primary', apiName: 'activeTrainingCourse', successText: '激活成功'}]
        : []
    default:
      return []
  }
}

export function isCourseRelationEditLocked (id, status) {
  return Number(id) > 0 && [
    consts.STATUS_ONLINE,
    consts.STATUS_OFFLINE,
  ].includes(Number(status))
}

export function buildCourseKnowledgeQueryParams ({is_common: isCommon, customerid}) {
  const params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon),
  }

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid]
  }

  return params
}

export const COURSE_UPLOAD_TYPE_CONFIGS = {
  [consts.CONTENT_TYPE_IMAGE]: {
    accept: ['image/jpeg', 'image/png', 'image/jpg'],
    extensions: ['jpg', 'jpeg', 'png'],
    maxFiles: 0,
    maxSizeMB: 20,
    tip: '支持 JPG、PNG，可上传多张，单个最大 20MB',
  },
  [consts.CONTENT_TYPE_VIDEO]: {
    accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
    extensions: ['mp4', 'avi', 'mov'],
    maxFiles: 1,
    maxSizeMB: 1024,
    tip: '只能上传一个视频，支持 MP4、AVI、MOV，最大 1GB',
  }
  // [consts.CONTENT_TYPE_DOCUMENT]: {
  //   accept: ['application/pdf'],
  //   extensions: ['pdf'],
  //   maxFiles: 1,
  //   maxSizeMB: 100,
  //   tip: '只能上传一个 PDF，最大 100MB',
  // },
}

export function getFileExtension (name) {
  const parts = String(name || '').split('.')
  return parts.length > 1 ? parts.pop().toLowerCase() : ''
}

export function getCourseContentTypeByFile (file) {
  const type = String((file && file.type) || '')
  const ext = getFileExtension(file && file.name)

  if (type.indexOf('image/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_IMAGE
  }
  if (type.indexOf('video/') === 0 || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_VIDEO].extensions.includes(ext)) {
    return consts.CONTENT_TYPE_VIDEO
  }
  // if (type === 'application/pdf' || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_DOCUMENT].extensions.includes(ext)) {
  //   return consts.CONTENT_TYPE_DOCUMENT
  // }
  return 0
}

export function getCourseUploadConfig (contentType) {
  if (!contentType) {
    const configs = Object.keys(COURSE_UPLOAD_TYPE_CONFIGS).map(type => COURSE_UPLOAD_TYPE_CONFIGS[type])
    return {
      accept: configs.reduce((result, item) => result.concat(item.accept), []),
      extensions: configs.reduce((result, item) => result.concat(item.extensions), []),
      maxFiles: 0,
      maxSizeMB: Math.max.apply(null, configs.map(item => item.maxSizeMB)),
      tip: '支持上传图片、视频；图片可上传多张，视频只能上传一个',
    }
  }

  return COURSE_UPLOAD_TYPE_CONFIGS[Number(contentType)] || COURSE_UPLOAD_TYPE_CONFIGS[consts.CONTENT_TYPE_IMAGE]
}

export function validateCourseUploadFile (file, currentFiles = [], currentContentType = 0) {
  const contentType = getCourseContentTypeByFile(file)
  if (!contentType) {
    return {
      valid: false,
      contentType,
      message: getCourseUploadConfig().tip,
      replaceAll: false,
    }
  }

  const config = getCourseUploadConfig(contentType)
  const currentCount = Array.isArray(currentFiles) ? currentFiles.length : 0
  const maxSize = config.maxSizeMB * 1024 * 1024
  const ext = getFileExtension(file && file.name)

  if (!file || (!config.accept.includes(file.type) && !config.extensions.includes(ext))) {
    return {
      valid: false,
      contentType,
      message: config.tip,
      replaceAll: false,
    }
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      contentType,
      message: config.tip,
      replaceAll: false,
    }
  }

  if (config.maxFiles === 1) {
    return {
      valid: true,
      contentType,
      message: '',
      replaceAll: currentCount >= 1 || currentFiles.some(item => Number(item.content_type || item.type || currentContentType) !== contentType),
    }
  }

  return {
    valid: true,
    contentType,
    message: '',
    replaceAll: currentFiles.some(item => Number(item.content_type || item.type || currentContentType) !== contentType),
  }
}



// WEBPACK FOOTER //
// ./src/views/training/training-course.constants.js